import { render } from "./Cursos.vue?vue&type=template&id=552e991c&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"

import "./Cursos.vue?vue&type=style&index=0&id=552e991c&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552e991c"]])

export default __exports__